module.exports = __webpack_public_path__ + "img/bulb.56ab99a6.png";